//// DEVICE

// check if on mobile device
export function isMobileDevice() 
{
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    return /android|avantgo|blackberry|iphone|ipad|ipod|iemobile|opera mini|mobile|palm|windows ce|windows phone|webos/i.test(userAgent)
}

// check if android device
export function isAndroidDevice()
{
    return /android/i.test(navigator.userAgent)
}

// check if iOS device
export function isIOSDevice()
{
    return /iphone|ipad|ipod/i.test(navigator.userAgent)
}

// check if on mobile resolution
export function isMobileResolution() 
{
    return window.matchMedia("(max-width: 800px)").matches
}

export function isSmallMobileResolution()
{
    return window.matchMedia("(max-width: 600px)").matches
}